import React, { useState, useRef, useEffect, useCallback } from "react";
import cycleBg from "../Img/cycle1.png";
import cycleDetailImage from "../Img/cycle-detail-image.png";
import contactFormBg from "../Img/contact-form-bg.png";
import scoop01 from "../Img/scoop/01.png";
import scoop02 from "../Img/scoop/02.png";
import scoop03 from "../Img/scoop/03.png";
import scoop04 from "../Img/scoop/04.png";
import scoop05 from "../Img/scoop/05.png";
import scoop06 from "../Img/scoop/06.png";
import scoop07 from "../Img/scoop/07.png";
import scoop08 from "../Img/scoop/08.png";
import scoop09 from "../Img/scoop/09.png";
import scoop10 from "../Img/scoop/10.png";
import scoop11 from "../Img/scoop/11.png";
import scoop12 from "../Img/scoop/12.png";
import brand1 from "../Img/brand/brand1.png";
import brand2 from "../Img/brand/brand2.png";
import brand3 from "../Img/brand/brand3.png";
import brand4 from "../Img/brand/brand4.png";
import brand5 from "../Img/brand/brand5.png";
import brand6 from "../Img/brand/brand6.png";
import person1 from "../Img/person1.jpg";
import person2 from "../Img/person2.jpg";
import person3 from "../Img/person3.jpg";
import person4 from "../Img/person4.jpg";
import {
  Bike,
  Package,
  Wind,
  RefreshCw,
  Bell,
  Shield,
  Video,
  Wrench,
  Repeat,
  PhoneCall,
  Star,
  Crown,
  Heart,
  Sparkles,
  Quote,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  ArrowRight,
  Phone,
  Mail,
  User,
  Smartphone,
  MessageCircle,
  CheckCircle,
  Droplets,
  Brush,
  Cog,
  Bike as BikeIcon,
  Sparkles as SparklesIcon,
} from "lucide-react";
import "../CSS/Global.css";
import "../CSS/CycleService.css";
import { Link } from "react-router-dom";

const CycleService = ({
  cartItemsLength,
  setCartItemLength,
  fetchCart,
  cartButtons,
}) => {
  const [activeFaq, setActiveFaq] = useState(null);
  const [startIndex, setStartIndex] = useState(0);
  const [activePackage, setActivePackage] = useState("non-gear");
  const [expanded, setExpanded] = useState({});

  // Create an array of images
  const scoopImages = [
    scoop01,
    scoop02,
    scoop03,
    scoop04,
    scoop05,
    scoop06,
    scoop07,
    scoop08,
    scoop09,
    scoop10,
    scoop11,
    scoop12,
  ];

  const services = {
    "non-gear": [
      {
        name: "STANDARD",
        desc: "Essential tune-up for non-gear cycles. Keeps your brakes sharp, chain smooth, and ride effortless every day",
        price: 299,
        includes: [
          "• General Tune Up",
          "• Hubs Checking & Headset Alignment",
          "• Front & Rear Brake Adjustment",
          "• Lube Chain & Cables",
          "• Soap Washing & Squeaky Clean Wiping",
          "• Correct Tire Inflation",
        ],
        duration: "4 Hours",
        Doorstep: " Available",
      },
      {
        name: "PREMIUM",
        desc: "Deep clean and full grease service with detailed inspection. Restores your cycle’s effortless, like-new glide",
        price: 199,
        includes: [
          "• Gear Tune Up",
          "• Dismantle, Grease & Re-install Hubs, Bottom Bracket & Headset",
          "• Front & Rear Brake Adjustment",
          "• Lube Chain & Cables (inner/outer)",
          "•  Soap Washing & Squeaky Clean Wiping",
          "• Correct Tire Inflation",
          "• Front & Rear Derailleur Adjustment",
          "• Front & Rear Brake Adjustment",
          "• Wheel True & Tension",
          "• Dismantle & clean Drivetrain",
        ],
        duration: "8 Hours",
        Doorstep: " Available",
      },
    ],
    gear: [
      {
        name: "STANDARD",
        desc: "Regular care for geared cycles. Keeps gear shifting crisp, braking precise, and performance consistent",
        price: 499,
        includes: [
          "• Gear Tune Up",
          "• Hubs Checking & Headset Alignment",
          "• Front & Rear Brake Adjustment",
          "• Lube Chain & Cables",
          "• Correct Tire Inflation",
          "• Front & Rear Derailleur Adjustment",
          "• Bottom Bracket Adjustment",
        ],
        duration: "5 hours",
        Doorstep: " Available",
      },
      {
        name: "PREMIUM",
        desc: " Deep-clean overhaul with full gear tuning and greasing. Brings back that smooth, like-new ride feel ",
        price: 399,
        includes: [
          "• Gear Tune Up",
          "• Front & Rear Brake Adjustment",
          "• Correct Tire Inflation",
          "• Front & Rear Derailleur Adjustment",
          "• Bottom Bracket Adjustment",
          "• Wheel True & Tension",
          "• Dismantle & clean Drivetrain",
        ],
        duration: "8 hours",
        Doorstep: " Available",
      },
      {
        name: "PRO",
        desc: " Complete precision service with drivetrain detailing, anti-rust protection, and expert tuning for peak performance ",
        price: 599,
        includes: [
          "• Gear Tune Up",
          "• Front & Rear Brake Adjustment",
          "• Front & Rear Derailleur Adjustment",
          "• Bottom Bracket Adjustment",
          "• Wheel True & Tension",
          "• Dismantle & clean Drivetrain",
          "• Bottom Bracket Adjustment",
          "• Wheel True & Tension",
          "• Dismantle & clean Drivetrain",
          "• Advanced Component Cleaning",
          "• High-end Lubrication",
          "• Extended Warranty",
          "• Anti-Rust Treatment",
        ],
        duration: "12 hours",
        Doorstep: " Available",
      },
    ],
    kids: [
      {
        name: "STANDARD (Upto size 20T) ",
        desc: "Safe and simple tune-up to keep your child’s cycle smooth, sturdy, and easy to ride ",
        price: 249,
        includes: [
          "• General Tune Up",
          "• Hubs Checking & Headset Alignment",
          "• Front & Rear Brake Adjustment",
          "• Lube Chain & Cables",
          "• Soap Washing & Squeaky Clean Wiping",
          "• Correct Tire Inflation",
        ],
        duration: "3 Hours",
        Doorstep: " Available",
      },
      {
        name: "PREMIUM (Upto size 20T)",
        desc: "Full clean and grease service with safety checks on every part. Keeps the ride light, fun, and worry-free ",
        price: 179,
        includes: ["• Reflectors",
           "• Bell check",
           "• Gear Tune Up",
           " Dismantle, Grease & Re-install Hubs, Bottom Bracket & Headset",
           " Front & Rear Brake Adjustment",
           " Lube Chain & Cables (inner/outer)",
           " Soap Washing & Squeaky Clean Wiping",
           " Correct Tire Inflation",
           " Front & Rear Derailleur Adjustment",
           " Bottom Bracket Adjustment",
           " Wheel True & Tension",
           " Dismantle & clean Drivetrain",
          ],
        duration: "5 Hours",
        Doorstep: " Available",
      },
    ],
  };

  const addOnServices = [
    {
      category: "Anti Rust",
      services: [
        { name: "BASIC", price: "349" },
        { name: "ADVANCE", price: "499" },
      ],
      hasButton: false,
    },
    {
      category: "Sanding & Touchup",
      services: [
        { name: "BASIC", price: "349" },
        { name: "ADVANCE", price: "599" },
      ],
      hasButton: false,
    },
    {
      category: "Suspension Overhaul",
      services: [
        { name: "REGULAR", price: "499" },
        { name: "LOCK OUT", price: "699" },
      ],
      hasButton: false,
    },
    {
      category: "Hydraulic Brake Bleeding",
      services: [
        { name: "SINGLE", price: "799" },
        { name: "BOTH", price: "1,499" },
      ],
      hasButton: true,
    },
    {
      category: "Cycle Assembly",
      services: [
        { name: "NON GEAR", price: "499" },
        { name: "GEAR", price: "699" },
      ],
      hasButton: true,
    },
    {
      category: "Dismantling & Packaging",
      services: [
        { name: "NON GEAR / GEAR", price: "999" },
        { name: "ROAD BIKE", price: "1,199" },
      ],
      hasButton: true,
    },
  ];

  const testimonials = [
    {
      name: "Vishal Desai",
      rating: 5,
      text: "I rented a bicycle from Cycle Rental Service last month and it was in excellent condition. The whole rental process was quick and very simple. Riding the cycle was a great experience and I will definitely rent again in the future. I highly recommend Cycle Rental Service to anyone looking for a reliable cycle rental.",
      image: person1,
    },
    {
      name: "Shraddha Aryaa",
      rating: 5,
      text: "Renting a cycle from Cycle Rental Service was a wonderful experience for me. After my second baby, I wanted to get back into a healthy routine and cycling helped a lot. The bicycles were comfortable and the team was extremely supportive. I truly appreciate their service and wish them continued success.",
      image: person2,
    },
    {
      name: "Alisha Pereira",
      rating: 5,
      text: "My experience with Cycle Rental Service was very smooth from the first enquiry to the delivery and pickup of the bicycle. I wanted to relearn cycling after many years and their team was very helpful. They even suggested the right cycle based on my height, which made the ride comfortable and enjoyable.",
      image: person3,
    },
    {
      name: "Binnita Shah",
      rating: 5,
      text: "I was searching online to rent cycles for myself and my brother when I found Cycle Rental Service. The team was very friendly and helped us even on short notice during a Sunday. They took the time to understand our plans and recommended the best cycles for us. It was a great experience overall.",
      image: person4,
    },
  ];

  const toggleExpanded = (id) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <Star
        key={index}
        size={16}
        className={index < rating ? "star-filled" : "star-empty"}
        fill={index < rating ? "currentColor" : "none"}
      />
    ));
  };

  const nextSlide = () => {
    if (startIndex + 3 < testimonials.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const prevSlide = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  return (
    <div className="min-h-screen">
      <section className="hero-section-complete">
        <div className="hero-bg-spot spot-1"></div>
        <div className="hero-bg-spot spot-2"></div>
        <div className="container">
          {/* Main Hero Content */}
          <div className="hero-main-content">
            <h1 className="hero-main-title">
              <span>Professional Bicycle Service & Repair</span>
              <span className="hero-location">in Mumbai</span>
            </h1>
            <Link to="/products" className="hero-main-btn">
              Get Started
            </Link>
          </div>

          {/* Service Features Cards */}
          <div className="hero-features-grid">
            <div className="hero-feature-card">
              <div className="hero-feature-icon-title">
                <Shield className="hero-feature-icon" />
                <h3>7-Day Service Warranty</h3>
              </div>
            </div>

            <div className="hero-feature-card">
              <div className="hero-feature-icon-title">
                <Sparkles className="hero-feature-icon" />
                <h3>Authentic Quality Parts</h3>
              </div>
            </div>

            <div className="hero-feature-card">
              <div className="hero-feature-icon-title">
                <Package className="hero-feature-icon" />
                <h3>Pickup & Home Delivery</h3>
              </div>
            </div>

            <div className="hero-feature-card">
              <div className="hero-feature-icon-title">
                <Smartphone className="hero-feature-icon" />
                <h3>Real-Time Service Updates</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cycle Service Packages */}
      <section className="packages-section">
        <div className="container">
          <h2 className="section-title packages-title">
            Bicycle Service Plans
          </h2>
          <div className="packages-tabs">
            <button
              className={`packages-tab ${activePackage === "non-gear" ? "active" : ""}`}
              onClick={() => setActivePackage("non-gear")}
            >
              Non Gear
            </button>
            <button
              className={`packages-tab ${activePackage === "gear" ? "active" : ""}`}
              onClick={() => setActivePackage("gear")}
            >
              Gear
            </button>
            <button
              className={`packages-tab ${activePackage === "kids" ? "active" : ""}`}
              onClick={() => setActivePackage("kids")}
            >
              Kids
            </button>
          </div>
          <div className="packages-cards">
            {services[activePackage].map((service, index) => (
              <div key={`${activePackage}-${index}`} className="service-card">
                <div className="service-header">
                  <h3>{service.name}</h3>
                  <button
                    className="expand-btn"
                    onClick={() => toggleExpanded(`${activePackage}-${index}`)}
                  >
                    {expanded[`${activePackage}-${index}`] ? (
                      <ChevronUp size={20} />
                    ) : (
                      <ChevronDown size={20} />
                    )}
                  </button>
                </div>
                <p>{service.desc}</p>
                {expanded[`${activePackage}-${index}`] && (
                  <div className="service-details">
                    <div className="detail-row">
                      <span>Includes:</span>
                      <div className="includes-list">
                        {service.includes.map((item, i) => (
                          <div key={i} className="include-item">
                            <CheckCircle
                              size={16}
                              className="include-icon-small mr-2"
                            />
                            {item}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="detail-row">
                      <span>Duration:</span>
                      <span>{service.duration}</span>
                    </div>
                    <div className="detail-row">
                      <span>Place of Service:</span>
                      <span>Our Workshop</span>
                    </div>
                    <div className="detail-row">
                      <span>Doorstep Pickup & Drop</span>
                      <span>{service.Doorstep}</span>
                    </div>
                  </div>
                )}
                <button className="book-btn">
                  Book Now for ₹{service.price}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="addon-services-section">
        <div className="container">
          <h2 className="section-title">Additional Services</h2>

          <div className="addon-services-grid">
            {addOnServices.map((service, index) => (
              <div className="addon-service-card" key={index}>
                <h3 className="addon-service-category">{service.category}</h3>

                <div className="addon-service-prices">
                  {/* Display services in two columns */}
                  <div className="addon-service-row">
                    <div className="addon-service-column">
                      <div className="addon-service-type">
                        {service.services[0].name}
                      </div>
                      <div className="addon-service-price">
                        Rs {service.services[0].price}
                      </div>
                    </div>
                    <div className="addon-service-column">
                      <div className="addon-service-type">
                        {service.services[1].name}
                      </div>
                      <div className="addon-service-price">
                        Rs {service.services[1].price}
                      </div>
                    </div>
                  </div>
                </div>

                {service.hasButton && (
                  <div className="addon-service-footer">
                    <Link to="/book-service" className="addon-book-now-btn">
                      Book Now
                    </Link>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Cycle Service Process Section */}
      <section className="service-process-section">
  <div className="service-process-bg-spot spot-center"></div>
  <div className="container">
    <h2 className="section-title">
      <span className="black-text">Our Cycle Care Process</span>{" "}
      <span className="blue-text">~ Built around your needs</span>
    </h2>

    <div className="service-process-list">
      {/* Step 1 */}
      <div className="service-process-item">
        <div className="service-process-number">1</div>
        <div className="service-process-content">
          <h3>Doorstep Pickup</h3>
          <p>
            We collect your bicycle from your location and safely transport it
            to our service center.
          </p>
        </div>
      </div>

      {/* Step 2 */}
      <div className="service-process-item">
        <div className="service-process-number">2</div>
        <div className="service-process-content">
          <h3>Initial Inspection Photos</h3>
          <p>
            Before starting, we share images of your cycle’s current condition
            so you stay fully informed.
          </p>
        </div>
      </div>

      {/* Step 3 */}
      <div className="service-process-item">
        <div className="service-process-number">3</div>
        <div className="service-process-content">
          <h3>Detailed Breakdown Check</h3>
          <p>
            Your cycle is carefully inspected and dismantled where needed, with
            updates shared for complete transparency.
          </p>
        </div>
      </div>

      {/* Step 4 */}
      <div className="service-process-item">
        <div className="service-process-number">4</div>
        <div className="service-process-content">
          <h3>Service & Cost Estimate</h3>
          <p>
            We provide a clear summary of required work along with an estimated
            cost before proceeding.
          </p>
        </div>
      </div>

      {/* Step 5 */}
      <div className="service-process-item">
        <div className="service-process-number">5</div>
        <div className="service-process-content">
          <h3>After-Service Updates</h3>
          <p>
            Once servicing is complete, we share updated photos showing the
            improvements made.
          </p>
        </div>
      </div>

      {/* Step 6 */}
      <div className="service-process-item">
        <div className="service-process-number">6</div>
        <div className="service-process-content">
          <h3>Easy Billing</h3>
          <p>
            A detailed invoice is sent for quick and hassle-free payment.
          </p>
        </div>
      </div>

      {/* Step 7 */}
      <div className="service-process-item">
        <div className="service-process-number">7</div>
        <div className="service-process-content">
          <h3>Delivery to Your Door</h3>
          <p>
            Your serviced cycle is delivered back to you, fully ready for a
            smooth and enjoyable ride.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>


      {/* The Inside Scoop Section */}
      <section className="inside-scoop-section">
        <div className="container">
          <h2 className="section-title">Inside The Journey</h2>

          <div className="rowgallery">
            {/* Column 1 */}
            <div className="columngallery">
              <img
                src={scoop01}
                alt="Inside Scoop 1"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop05}
                alt="Inside Scoop 5"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop09}
                alt="Inside Scoop 9"
                style={{ width: "100%", marginBottom: "6px" }}
              />
            </div>

            {/* Column 2 */}
            <div className="columngallery">
              <img
                src={scoop02}
                alt="Inside Scoop 2"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop06}
                alt="Inside Scoop 6"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop10}
                alt="Inside Scoop 10"
                style={{ width: "100%", marginBottom: "6px" }}
              />
            </div>

            {/* Column 3 */}
            <div className="columngallery">
              <img
                src={scoop03}
                alt="Inside Scoop 3"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop07}
                alt="Inside Scoop 7"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop11}
                alt="Inside Scoop 11"
                style={{ width: "100%", marginBottom: "6px" }}
              />
            </div>

            {/* Column 4 */}
            <div className="columngallery">
              <img
                src={scoop04}
                alt="Inside Scoop 4"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop08}
                alt="Inside Scoop 8"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop12}
                alt="Inside Scoop 12"
                style={{ width: "100%", marginBottom: "6px" }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-carousel-section">
        <div className="container">
          <h2 className="section-title">What Our Riders Say</h2>

          <div className="testimonials-carousel-container">
            <button
              className={`carousel-arrow carousel-arrow-left ${startIndex === 0 ? "disabled" : ""}`}
              onClick={prevSlide}
              disabled={startIndex === 0}
            >
              <ChevronLeft size={24} />
            </button>

            <div className="testimonials-carousel-track">
              {testimonials
                .slice(startIndex, startIndex + 3)
                .map((testimonial, index) => (
                  <div
                    key={startIndex + index}
                    className="testimonial-carousel-card"
                  >
                    <div className="testimonial-header">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="testimonial-image"
                      />
                      <div className="testimonial-info">
                        <h4>{testimonial.name}</h4>
                        <div className="testimonial-rating">
                          {renderStars(testimonial.rating)}
                        </div>
                      </div>
                    </div>

                    <div className="testimonial-content">
                      <p>"{testimonial.text}"</p>
                    </div>
                  </div>
                ))}
            </div>

            <button
              className={`carousel-arrow carousel-arrow-right ${startIndex + 3 >= testimonials.length ? "disabled" : ""}`}
              onClick={nextSlide}
              disabled={startIndex + 3 >= testimonials.length}
            >
              <ChevronRight size={24} />
            </button>
          </div>

          <div className="carousel-dots">
            {Array.from({ length: Math.ceil(testimonials.length - 2) }).map(
              (_, index) => (
                <button
                  key={index}
                  className={`carousel-dot ${index === startIndex ? "active" : ""}`}
                  onClick={() => setStartIndex(index)}
                />
              ),
            )}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2 className="section-title">
            <span className="black-text">Frequently Asked</span>{" "}
            <span className="blue-text">Questions</span>
          </h2>

          <div className="faq-grid">
            {/* FAQ Item 1 */}
            <div className={`faq-item ${activeFaq === 0 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(0)}>
                <h3>How long does cycle service take?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 0 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  Basic service takes 45 mins to 1 hour, while complete overhaul
                  may take 2-3 hours depending on the service package you
                  choose.
                </p>
              </div>
            </div>

            {/* FAQ Item 2 */}
            <div className={`faq-item ${activeFaq === 1 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(1)}>
                <h3>Do you provide doorstep pickup and delivery?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 1 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  Yes, we offer free doorstep pickup and delivery for all our
                  service packages within Mumbai.
                </p>
              </div>
            </div>

            {/* FAQ Item 3 */}
            <div className={`faq-item ${activeFaq === 2 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(2)}>
                <h3>What is the warranty on your service?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 2 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  We provide 7 days warranty on all our services. If you face
                  any issue within 7 days, we'll fix it free of cost.
                </p>
              </div>
            </div>

            {/* FAQ Item 4 */}
            <div className={`faq-item ${activeFaq === 3 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(3)}>
                <h3>Do I need to book an appointment?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 3 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  Yes, we recommend booking an appointment to ensure smooth
                  service. You can book directly through our website.
                </p>
              </div>
            </div>

            {/* FAQ Item 5 */}
            <div className={`faq-item ${activeFaq === 4 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(4)}>
                <h3>What payment methods do you accept?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 4 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  We accept all major payment methods including UPI,
                  Credit/Debit cards, Net Banking, and Cash on delivery.
                </p>
              </div>
            </div>

            {/* FAQ Item 6 */}
            <div className={`faq-item ${activeFaq === 5 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(5)}>
                <h3>Do you use genuine parts for replacement?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 5 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  Yes, we use 100% genuine parts for all replacements. You can
                  also request specific brands if needed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Brands We Deal In Section */}
      <section className="brands-section">
        <div className="container">
          <h2 className="section-title">
            <span className="brands-title">Brands We Work With</span>
          </h2>

          <div className="brands-grid">
            <img src={brand1} alt="BTWIN" className="brand-item" />
            <img src={brand2} alt="FIREFOX" className="brand-item" />
            <img src={brand3} alt="GIANT" className="brand-item" />
            <img src={brand4} alt="SCOTT" className="brand-item" />
            <img src={brand5} alt="TREK" className="brand-item" />
            <img src={brand6} alt="ALVANTI" className="brand-item" />
          </div>

          <p className="brands-more">...and a lot more.</p>
        </div>
      </section>

      <section className="help-section">
        <div className="help-overlay"></div>
        <div className="container">
          <div className="help-content">
            <h2 className="help-title"> Have Questions? </h2>

            <div className="help-contact">
              <div className="help-contact-item">
                <Phone size={20} />
                <a href="tel:+919820760684">+91 9820760684</a>
              </div>
              <div className="help-contact-item">
                <Mail size={20} />
                <a href="mailto:hello@twinring.in">hello@twinring.in</a>
              </div>
            </div>

            <form className="help-form">
              <div className="form-group">
                <User size={18} className="form-icon" />
                <input type="text" placeholder="Full Name" />
              </div>

              <div className="form-group">
                <Smartphone size={18} className="form-icon" />
                <input type="tel" placeholder="Mobile Number" />
              </div>

              <div className="form-group">
                <Mail size={18} className="form-icon" />
                <input type="email" placeholder="Email" />
              </div>

              <div className="form-group">
                <MessageCircle size={18} className="form-icon" />
                <input type="text" placeholder="What are you looking for?" />
              </div>

              <button type="submit" className="help-submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CycleService;
